export { default } from './InputCurrency';
